import useSWR from 'swr';
import { authenticatedFetcher } from '@/lib/swr';
import type { Person } from '@/types';
import { PP_BASE_URL } from '@/lib/env';

type ProfileResponse = {
  data?: Person;
  ok?: boolean;
};

export function useGetMyProfile() {
  const baseUrl = PP_BASE_URL?.replace(/\/$/, '');
  const key = baseUrl ? `${baseUrl}/account/me` : null;

  const {
    data: response,
    error,
    isLoading,
    mutate,
  } = useSWR<ProfileResponse | Person>(key, authenticatedFetcher, {
    revalidateOnMount: true,
    revalidateOnFocus: false,
    dedupingInterval: 5000,
    shouldRetryOnError: (err: any) => err?.status !== 404,
  });

  // BaseController returns ApiResponse with data property, or plain object
  const person: Person | undefined = (response as ProfileResponse)?.data ?? (response as Person);

  return {
    swrKey: key,
    person,
    data: response,
    isLoading,
    error,
    mutate,
  };
}
